<template>
  <div class="loader">
    <div v-for="i in 2" :key="i" class="product-card">
      <GFMP :styles="{ ...fmpStyles.rounded, height: '48px', width: '48px' }" />
      <div class="product-card-content">
        <div v-for="_i in 4" :key="_i">
          <div v-if="_i === 3" class="product-card-content-rating">
            <GFMP v-for="__i in 5" :key="__i" :styles="{ ...fmpStyles.circle, height: '16px', minWidth: '16px' }" />
          </div>
          <GFMP v-else :styles="{ ...fmpStyles.rounded, width: _i === 4 ? '96px' : '160px' }" />
        </div>
      </div>
      <GFMP :styles="{ ...fmpStyles.circle, height: '20px' }" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'recently-bought-loader',
  props: {
    perPageCustomProps: {
      type: Number,
      required: false,
      default: () => 6,
    },
  },
  data() {
    return {
      fmpStyles: {
        rounded: {
          borderRadius: '8px',
          height: '12px',
        },
        circle: {
          borderRadius: '50%',
          height: '12px',
        },
      },
    };
  },
};
</script>

<style lang="scss" scoped>
@import './src/assets/sass/_mixin-revamp.scss';

.loader {
  display: flex;
  gap: 32px;
  justify-content: end;

  .product {
    &-card {
      display: flex;
      gap: 8px;
      width: max-content;

      &-content {
        display: flex;
        flex-direction: column;
        gap: 8px;
        width: max-content;

        &-rating {
          display: flex;
          gap: 8px;
        }
      }
    }
  }
}
</style>
